import axios from 'axios';
import { ConfigurationData, AnalyticsConfiguration } from "./configuration/ConfigurationData";

const configResponse = await axios.get<ConfigurationData>(`app.config.json`);
export const appConfiguration = configResponse.data;

export function initializeGoogleAnalytics(): void {
    const config = appConfiguration.analytics;
    if (!config?.enabled || !config.measurementId) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src =
        `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.measurementId)}`;

    document.head.appendChild(script);

    const scriptOther = document.createElement('script');
    
    scriptOther.innerHTML = 'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag("js", new Date());gtag("config", "G-69DTTW61WD");';
    
    document.head.appendChild(scriptOther);
}
